import Logo from '../../assets/logo/aveda-logo.svg';
import { Global } from '@emotion/react';
import {
  globalLogin,
  LoginContainer,
  LoginLogo,
  LoginTitle,
  StyledLoader,
} from '../Login/Login.styles';
import { useTranslation } from 'react-i18next';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import URLs from '../URLs';
import { useNotification } from '../../components';

const Auth = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const navigate = useNavigate();
  const { showMessage } = useNotification();

  useEffect(() => {
    if (import.meta.env.DEV) {
      Cookies.set('user_id', '775');
      return;
    }
    const cookies = Object.keys(Cookies.get());
    if (
      cookies.some((cookie) => cookie.startsWith('SSES') || cookie.startsWith('SESS')) &&
      cookies.includes('csrf_token') &&
      cookies.includes('logout_token') &&
      cookies.includes('user_id')
    ) {
      navigate(URLs.ROOT);
      return;
    }
    axios
      .post(
        `${import.meta.env.VITE_APP_BACKEND_URL}/api/v1/user/login?_format=json`,
        { code, state },
        { withCredentials: true },
      )
      .then(({ data: { current_user } }) => {
        Cookies.set('csrf_token', current_user.csrf_token);
        Cookies.set('logout_token', current_user.logout_token);
        Cookies.set('user_id', current_user.uid);
        navigate(URLs.ROOT);
      })
      .catch((error) => {
        if (error.response?.status === 403) {
          showMessage('Please log out from SOAP CMS and try to login into the Web Application one more time.', 'error');
          navigate(URLs.Login);
          return;
        }
        showMessage(
          error.response?.data
            ? error.response.data.message || error.response.data?.toString()
            : error.message,
          'error',
        );
      });
  }, [code, navigate, showMessage, state]);

  return (
    <>
      <Global styles={globalLogin} />
      <LoginContainer maxWidth="sm">
        <LoginLogo src={Logo} alt="Aveda" />
        <LoginTitle variant="h4">{t('login.appTitle')}</LoginTitle>
        <StyledLoader />
      </LoginContainer>
    </>
  );
};

export default Auth;
